import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

var PropsTable =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(PropsTable, _PureComponent);

  function PropsTable() {
    _classCallCheck(this, PropsTable);

    return _possibleConstructorReturn(this, _getPrototypeOf(PropsTable).apply(this, arguments));
  }

  _createClass(PropsTable, [{
    key: "render",
    value: function render() {
      var propInfos = this.props.propInfos;
      return React.createElement("div", {
        className: "styled-table"
      }, React.createElement("h3", null, "Props"), React.createElement("div", null, React.createElement("table", {
        className: "table table-bordered"
      }, React.createElement("thead", null, React.createElement("tr", null, React.createElement("th", null, "Name"), React.createElement("th", null, "Type"), React.createElement("th", null, "Default"), React.createElement("th", null, "Description"))), React.createElement("tbody", null, propInfos.map(function (el) {
        return React.createElement(el.type, _extends({
          key: el.props.name
        }, el.props));
      })))));
    }
  }]);

  return PropsTable;
}(PureComponent);

export { PropsTable as default };
PropsTable.propTypes = {
  propInfos: PropTypes.arrayOf(PropTypes.node)
};